import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';

import type { Complexity, DevelopmentCategory } from '@/shared/utils/format-status.js';
import { DEVELOPMENT_CATEGORIES } from '@/shared/utils/format-status.js';

interface DevelopmentEstimateFieldsProps {
    translate: (key: string) => string;
    category: DevelopmentCategory | '';
    onCategoryChange: (value: DevelopmentCategory | '') => void;
    functionalComplexity: Complexity | '';
    onFunctionalComplexityChange: (value: Complexity | '') => void;
    functionalHours: string;
    onFunctionalHoursChange: (value: string) => void;
    estimatedDeliveryDate: string;
    onEstimatedDeliveryDateChange: (value: string) => void;
}

const COMPLEXITY_OPTIONS: Complexity[] = ['MUITO_BAIXA', 'BAIXA', 'MEDIA', 'ALTA', 'MUITO_ALTA'];

export function DevelopmentEstimateFields({
    translate,
    category,
    onCategoryChange,
    functionalComplexity,
    onFunctionalComplexityChange,
    functionalHours,
    onFunctionalHoursChange,
    estimatedDeliveryDate,
    onEstimatedDeliveryDateChange
}: DevelopmentEstimateFieldsProps) {
    return (
        <>
            <TextField
                select
                size="small"
                fullWidth
                required
                label={translate('devForm.fieldCategory')}
                value={category}
                onChange={(e) => onCategoryChange(e.target.value as DevelopmentCategory | '')}
            >
                <MenuItem value="" disabled>
                    {translate('devForm.selectCategory')}
                </MenuItem>
                {DEVELOPMENT_CATEGORIES.map((c) => (
                    <MenuItem key={c} value={c}>
                        {translate(`devForm.categoryLabels.${c}`)}
                    </MenuItem>
                ))}
            </TextField>
            <TextField
                select
                size="small"
                fullWidth
                required
                label={translate('devForm.fieldFunctionalComplexity')}
                value={functionalComplexity}
                onChange={(e) => onFunctionalComplexityChange(e.target.value as Complexity | '')}
            >
                <MenuItem value="" disabled>
                    {translate('estimate.selectComplexity')}
                </MenuItem>
                {COMPLEXITY_OPTIONS.map((c) => (
                    <MenuItem key={c} value={c}>
                        {translate(`complexityLabels.${c}`)}
                    </MenuItem>
                ))}
            </TextField>
            <TextField
                type="number"
                size="small"
                fullWidth
                required
                label={translate('devForm.fieldFunctionalHours')}
                placeholder={translate('estimate.hoursPlaceholder')}
                value={functionalHours}
                onChange={(e) => onFunctionalHoursChange(e.target.value)}
                inputProps={{ min: 1 }}
            />
            <TextField
                type="date"
                size="small"
                fullWidth
                label={translate('devForm.fieldEstimatedDeliveryDate')}
                value={estimatedDeliveryDate}
                onChange={(e) => onEstimatedDeliveryDateChange(e.target.value)}
                slotProps={{ inputLabel: { shrink: true } }}
            />
        </>
    );
}
